import { render } from "./legup-actions.vue?vue&type=template&id=68ec1068&scoped=true"
import script from "./legup-actions.vue?vue&type=script&lang=js"
export * from "./legup-actions.vue?vue&type=script&lang=js"

import "./legup-actions.vue?vue&type=style&index=0&id=68ec1068&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ec1068"]])

export default __exports__